<template>
  <div class="lcu-auth-nav" :class="{
      'lcu-auth-navISO': _device.iPhone && _device.app,
    }">
    <div class="lcu-nav-wrap">
      <div class="lcu-auth-inner">
        <div class="lcu-auth-left">
          <router-link to="/panel-de-control">
            <img
              class="lcu-auth-navLogo"
              src="/assets/lcu-logo-gold-wide.svg"
              alt="LCU Dashboard Logo" />
          </router-link>
        </div>
        <div class="lcu-auth-right">
          <a
            :class="{
              'lcu-auth-active': $router.currentRoute.value.path === '/panel-de-control',
            }"
            href="#"
            class="lcu-auth-link lcu-icon-dashboard"
            @click.prevent="checkLink('/panel-de-control')">
            Panel de control
          </a>
          <a
            href="#"
            :class="{
              'lcu-auth-active': $router.currentRoute.value.path.match(/^\/programas/gi),
            }"
            class="lcu-auth-link lcu-icon-programs"
            @click.prevent="checkLink('/programas')">
            Programas
          </a>
          <a
            href="#"
            :class="{
              'lcu-auth-active': $router.currentRoute.value.path.match(/^\/cuenta/gi),
            }"
            class="lcu-auth-link lcu-icon-account"
            @click.prevent="checkLink('/cuenta/perfil')">
            Mi Cuenta
          </a>
          <IconButton
            v-if="user.id"
            :classes="['lcu-icon-logout']"
            @on-click="confirmLogout = true"
            :icon="'lcu-logout'" />
        </div>
      </div>
    </div>
  </div>
  <LoginModal @set-modal="loginModal = false" :login-modal="loginModal" />
  <LogoutModal @set-modal="confirmLogout = false" :logout-modal="confirmLogout" />
</template>

<script>
import { mapGetters } from 'vuex';
import IconButton from 'ç/buttons/Icon.vue';
import LoginModal from 'ç/login-modal/LoginModal.vue';
import LogoutModal from 'ç/logout-modal/LogoutModal.vue';

export default {
  name: 'auth-nav',
  components: {
    LoginModal,
    IconButton,
    LogoutModal,
  },
  computed: {
    ...mapGetters(['user', 'userLoading']),
  },
  data() {
    return {
      loginModal: false,
      confirmLogout: false,
    };
  },
  methods: {
    checkLink(path) {
      if (!this.user.id) {
        this.loginModal = true;
        window.localStorage.setItem('lcuRequestedPath', path);
      } else {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-auth-nav {
  align-items: center;
  background-color: $legacy-primary;
  border-bottom: 1px solid rgba($white, .2);
  color: $light-gray-text;
  display: flex;
  height: $private-nav-height;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition-duration: .2s;
  width: 100%;
  z-index: 5;
  text-transform: uppercase;

  @media only screen and (max-width: $mobile-max) {
    border-right: none;
    border-top: 1px solid rgba($white, .2);
    bottom: 0;
    height: 70px;
    padding: 0;
    right: 0;
    top: auto;
    width: 100%;
    z-index: 10;
  }
}

.lcu-nav-wrap {
  max-width: 1280px;
  position: relative;
  width: 90%;
}

.lcu-auth-inner {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  padding: 3px;
  width: 100%;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
  }
}

.lcu-auth-navISO {

  .lcu-nav-wrap {
    top: -5px;

    @include ipad-pro-12 {
      top: 0;
    }
  }

  @media only screen and (max-width: $mobile-max) {
    height: 80px;
  }

  @include ipad-pro-12 {
    top: 25px;
  }
}

.lcu-auth-left {
  align-items: center;
  display: flex;
  justify-content: flex-start;

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}

.lcu-auth-right {
  align-items: center;
  display: flex;
  justify-content: flex-end;

  @media only screen and (max-width: $mobile-max) {
    justify-content: space-between;
  }
}

.lcu-auth-navLogo {
  margin-right: 35px;
  width: 120px;

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }

  @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
    margin-right: 15px;
  }
}

.lcu-auth-links {
  padding-top: 50px;

  @media only screen and (max-width: $mobile-max) {
    align-items: center;
    border-top: 1px solid rgba($white, .2);
    display: flex;
    justify-content: space-between;
    padding: 9px 20px 3px;
  }
}

.lcu-auth-linksISO {

  @media only screen and (max-width: $mobile-max) {
    padding: 10px 20px 5px;
  }
}

.lcu-auth-link {
  color: $light-gray-text;
  display: block;
  margin-right: 50px;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  transition-duration: .2s;
  white-space: nowrap;

  &:hover {
    color: $white;

    &:before {
      color: $white;
    }
  }

  &:before {
    display: inline-block;
    font-family: 'lcu';
    margin-right: 5px;
    transition-duration: .2s;
  }

  &:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }

  @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
    margin-right: 15px;
    font-size: 14px;
  }

  @media only screen and (max-width: $mobile-max) {
    display: inline-block;
    font-size: 13px;
    margin-bottom: 0;
    margin-right: 0;
    padding: 3px;
    text-decoration: center;

    &:before {
      display: block;
      font-size: 16px;
      margin-bottom: 5px;
      margin-right: 0;
      margin-left: 0;
      width: initial;
    }
  }
}

.lcu-auth-active {
  color: $white;
  font-weight: bold;

  &:before {
    color: $legacy-secondary;
  }
}

.lcu-icon-dashboard {

  &:before {
    content: '\e804';
  }
}

.lcu-icon-programs {

  &:before {
    content: '\e807';
  }
}

.lcu-icon-account {

  &:before {
    content: '\e80d';
  }
}

.lcu-icon-logout {
  color: $light-gray-text;
  transition-duration: .2s;

  &:hover {
    color: $white;
    transform: translateY(0);
  }

  @media only screen and (max-width: $mobile-max) {
    display: none;
  }
}

</style>
